import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css' // Vuesax
Vue.use(Vuesax)

// Theme Configurations
import '../themeConfig.js'

// Globally Registered Components
import './globalComponents.js'

// Styles: SCSS
import './assets/scss/main.scss'

// Tailwind
import '@/assets/css/main.css'

// Vue Router
import router from './router'

// Feather font icon
require('./assets/css/iconfont.css')

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)

// Vuex Store
import store from './store/store'

Vue.config.productionTip = false


// reloads site on dynamic import error
window.addEventListener("vite:preloadError", (event) => {
    console.log("error loading package", event);
    window.location.reload();
});

// Vue Scrollto

var VueScrollTo = require('vue-scrollto');
 
Vue.use(VueScrollTo)
Vue.use(VueScrollTo, {
     container: "body",
     duration: 500,
     easing: "ease",
     offset: 0,
     force: true,
     cancelable: true,
     onStart: false,
     onDone: false,
     onCancel: false,
     x: false,
     y: true
 })

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount('#app')
